import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN = "pdv_token";
const ADMIN_TOKEN = "pdv_admin_token";

// A sessão da aba vem primeiro: o contador abre o cliente numa aba própria sem perder o login do escritório
export const getToken = () => sessionStorage.getItem(TOKEN) || localStorage.getItem(TOKEN);
const DLG = "pdv_dlg";
export const isDelegated = () => sessionStorage.getItem(DLG) === "1";
const TOKEN_ESC = "pdv_token_escritorio";
export const storeDelegatedToken = (t) => {
  // se o escritório entrou sem "lembrar", o login dele estava só nesta aba: guarda para voltar ao painel depois
  const atual = sessionStorage.getItem(TOKEN);
  if (atual && !isDelegated()) sessionStorage.setItem(TOKEN_ESC, atual);
  sessionStorage.setItem(TOKEN, t);
  sessionStorage.setItem(DLG, "1");
};
export const storeToken = (t, remember) => {
  clearToken();
  (remember ? localStorage : sessionStorage).setItem(TOKEN, t);
};
export const clearToken = () => {
  if (isDelegated()) { // saída do contador do sistema do cliente: mantém o login do escritório
    const esc = sessionStorage.getItem(TOKEN_ESC);
    if (esc) sessionStorage.setItem(TOKEN, esc); else sessionStorage.removeItem(TOKEN);
    sessionStorage.removeItem(TOKEN_ESC);
    sessionStorage.removeItem(DLG);
    return;
  }
  localStorage.removeItem(TOKEN);
  sessionStorage.removeItem(TOKEN);
};

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const store = isDelegated() ? null : localStorage.getItem("pdv_store");
  if (store) cfg.headers["X-Store-Id"] = store;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && !url.includes("/auth/") && /^\/(app|m)(\/|$)/.test(window.location.pathname)) {
      const dlg = isDelegated();
      clearToken();
      window.location.href = dlg ? "/app/contabil" : "/login";
    }
    return Promise.reject(err);
  }
);

export const adminApi = axios.create({ baseURL: `${API}/admin` });
adminApi.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem(ADMIN_TOKEN);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const getAdminToken = () => sessionStorage.getItem(ADMIN_TOKEN);
export const setAdminToken = (t) => (t ? sessionStorage.setItem(ADMIN_TOKEN, t) : sessionStorage.removeItem(ADMIN_TOKEN));

export function errMsg(e, fallback = "Algo deu errado. Tente novamente.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message ? fallback : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
export const brl = (v) => BRL.format(Number(v) || 0);
export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—");
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("pt-BR") : "—");
export const fmtTime = (s) => (s ? new Date(s).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "—");
export const todayISO = (offset = 0) => {
  const d = new Date();
  d.setDate(d.getDate() - offset);
  return d.toLocaleDateString("sv-SE");
};

export const PAY_LABELS = { dinheiro: "Dinheiro", pix: "Pix", credito: "Cartão de crédito", debito: "Cartão de débito", vale_refeicao: "Vale Refeição", vale_alimentacao: "Vale Alimentação", transferencia: "Transferência", convenio: "Convênio", fiado: "Fiado", outros: "Outros", voucher: "Vale / Voucher", mercadopago: "Mercado Pago (online)" };
export const activeMethods = (session) => (session?.tenant?.pay_methods || []).filter((m) => m.active).map((m) => m.id);
export const PAY_METHODS = ["dinheiro", "pix", "credito", "debito", "transferencia", "convenio", "fiado", "outros"];
export const ORIGIN_LABELS = { balcao: "Balcão", mesa: "Mesa", comanda: "Comanda", delivery: "Delivery", cardapio: "Cardápio digital", estacionamento: "Estacionamento", encomenda: "Encomenda", ticket: "Venda ticket" };
export const STATUS_LABELS = { trial: "Teste ativo", expired: "Teste expirado", active: "Plano ativo", suspended: "Conta suspensa", cancelled: "Conta cancelada" };
export const SEGMENT_LABELS = { alimentacao: "Alimentação", varejo: "Varejo", servicos: "Serviços", estacionamento: "Estacionamento", contabilidade: "Escritório de contabilidade", outro: "Outro" };
export const ROLE_LABELS = { contador: "Contador", owner: "Proprietário", admin: "Administrador", gerente: "Gerente", caixa: "Caixa", garcom: "Garçom", cozinha: "Cozinha", entregador: "Entregador", estacionamento: "Operador de estacionamento", operator: "Caixa" };
export const ROLE_HINTS = { admin: "Acesso completo ao sistema", gerente: "Vendas, relatórios, produtos, clientes e operação", caixa: "Vendas e recebimentos", garcom: "Mesas e comandas", cozinha: "Pedidos e produção", entregador: "Pedidos destinados à entrega", estacionamento: "Entradas, saídas e tickets do estacionamento" };
export const PERM_LABELS = { cancel_sale: "Cancelar venda", apply_discount: "Aplicar desconto", change_price: "Alterar preço", view_reports: "Visualizar relatórios", open_cash: "Abrir caixa", close_cash: "Fechar caixa", change_stock: "Alterar estoque", edit_products: "Editar produtos", delete_records: "Excluir registros", reopen_comanda: "Reabrir comanda", change_payment: "Alterar formas de pagamento" };
export const UNIT_LABELS = { un: "Unidade (un)", kg: "Quilo (kg)", g: "Grama (g)", l: "Litro (l)", ml: "Mililitro (ml)", cx: "Caixa (cx)", pct: "Pacote (pct)", dz: "Dúzia (dz)", m: "Metro (m)" };
export const MOVE_LABELS = { entrada: "Entrada", saida: "Saída", ajuste: "Ajuste manual", perda: "Perda", inventario: "Inventário", venda: "Venda", estorno: "Estorno" };
export const CASH_MOVE_LABELS = { suprimento: "Reforço de caixa", sangria: "Sangria", entrada: "Entrada", saida: "Saída / despesa" };
export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
export const fmtQty = (v) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 3 });

const digits = (v) => (v || "").replace(/\D/g, "");
export const maskDoc = (v) => {
  const d = digits(v).slice(0, 14);
  if (d.length <= 11) return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return d.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
};
export const maskPhone = (v) => {
  const d = digits(v).slice(0, 11);
  if (d.length <= 10) return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2");
  return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");
};
export const maskCep = (v) => digits(v).slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");
export { digits };

export const isManagerRole = (u) => ["owner", "admin", "gerente"].includes(u?.role);
export const isAdminRole = (u) => ["owner", "admin"].includes(u?.role);
export const isManager = (u) => ["owner", "admin", "gerente"].includes(u?.role);
export const canDo = (u, perm) => !!u?.permissions?.includes(perm);
export const canSee = (u, area) => !!u?.areas?.includes(area);
export const waLink = (phone, text) => `https://wa.me/${(phone || "").replace(/\D/g, "").replace(/^(?!55)/, "55")}?text=${encodeURIComponent(text)}`;
export const MODULE_LABELS = { pdv: "PDV / Caixa", caixa: "Controle de caixa", encomendas: "Encomendas", mesas: "Mesas", comandas: "Comandas", delivery: "Delivery", fidelidade: "Fidelidade", producao: "Produção", tickets: "Tickets", estacionamento: "Estacionamento", cardapio: "Cardápio digital", produtos: "Produtos", estoque: "Estoque", clientes: "Clientes", relatorios: "Relatórios", motoboy: "Motoboy / Entregadores", boy_express: "Boy Express", fiscal: "Fiscal (NF-e, NFC-e e NFS-e)", folha: "Folha de pagamento", ponto: "Ponto e escala", contabil: "Escritório contábil" };
export const limitText = (n, one, many) => (n ? `Até ${n} ${n === 1 ? one : many}` : `${many[0].toUpperCase()}${many.slice(1)} ilimitados`);
export function hexToHsl(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((x) => x / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  let h = 0, s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h *= 60;
  }
  return { hsl: `${h.toFixed(1)} ${(s * 100).toFixed(1)}% ${(l * 100).toFixed(1)}%`, light: 0.299 * r + 0.587 * g + 0.114 * b > 0.62 };
}
